import { applyDefaultGradient, generateGradientFromImage } from '/js/Core'
import { Metrics } from '../Metrics'
import PlacePhoto = google.maps.places.PlacePhoto


let _onDismiss:(() => void)|null = null


async function initPlaceSheet( placeDetailsFetcher:( placeID:string ) => Promise<google.maps.places.PlaceResult>,
	onDismiss:() => void,
){
	_onDismiss = onDismiss
	
	const placeID = $('#place-data').attr( 'data-place-id' )
	const galleryContainer = $('.gallery-grid')
	galleryContainer.css( 'opacity', 0 )
	
	if( !placeID || !galleryContainer.length )
		return
	
	galleryContainer.off('click', '.photo-container')
	galleryContainer.on('click', '.photo-container', function(){
		Metrics.logNAV_viewPhotoGallery(placeID as string)
	})

	// load photos from Google Places API
	try {
		let place:google.maps.places.PlaceResult = await placeDetailsFetcher( placeID )
		const allPhotos = place.photos || []

		const galleryPhotos = allPhotos.slice( 1, 9 )
		
		let imagesToLoad = 0
		let imagesLoaded = 0

		galleryContainer.find( '.photo-container' ).each(( index:number, container:HTMLElement ) => {
			const photo:PlacePhoto = galleryPhotos[index]
			if( !photo ){
				$(container).hide()
				return
			}

			imagesToLoad++

			const img = $(container).find( '.lazy-image' )
			const thumbnailUrl:string = photo.getUrl({
				maxWidth: 260,
			})
			const proxyUrl = `/proxy-image?imageUrl=${encodeURIComponent( thumbnailUrl )}`

			img.attr( 'alt', `${place.name} - Photo ${index + 1}` )
			img.attr( 'src', proxyUrl )

			img.on('load', () => {
				$(container).find( '.placeholder' ).hide()
				img.show()
				imagesLoaded++
				if( imagesLoaded === imagesToLoad )
					galleryContainer.css( 'opacity', 1 )
			})

			img.on( 'error', ( x ) => {
				console.error( `Failed to load photo ${index + 1}:`, x )
				$(container).hide()
				imagesLoaded++
				if( imagesLoaded === imagesToLoad )
					galleryContainer.css( 'opacity', 1 )
			})

			$(container).attr( 'data-loading-state', 'loaded' )
		})
	} catch( x ){
		console.error( 'Error loading place details:', x )
	}
}


function isSafariBrowser():boolean{
	const ua:string = navigator.userAgent;
	const isSafari:boolean = /^((?!chrome|android).)*safari/i.test(ua);
	return isSafari;
}


export async function showPlaceModal( placeID:string, placeName:string,
	placeDetailsFetcher:(placeID:string) => Promise<google.maps.places.PlaceResult>, onDismiss:() => void
){
	const $body = $('body')
	const $dialog = $('#placeSheet')
	const $sheetBody = $dialog.find( '.sheet-body' )
	if( !$dialog.length || !$sheetBody.length )
		return

	$dialog.off( 'click close' )

	// progressive blur on scroll (use .place-sheet as scrollable)
	const $fixedNav = $('#fixed-navigation')

	// safari-only progressive blur
	if( !isSafariBrowser() ){
		$fixedNav.find('.navigation-gradient-blur').css('display','none')
		$fixedNav.addClass('no-blur')
	}else{
		$fixedNav.find('.navigation-gradient-blur').css('display','')
		$fixedNav.removeClass('no-blur')
	}
	function handleNavBlurOnScroll(){
		const scrollTop:number = $dialog.scrollTop()
		const translateY:number = scrollTop > 0 ? 0 : -48
		$fixedNav.find('.navigation-gradient-blur').css('transform', `translateY(${translateY}px)`)
		if( scrollTop > 0 ){
			$fixedNav.addClass('blur-visible')
		}else{
			$fixedNav.removeClass('blur-visible')
		}
	}
	$dialog.on('scroll', handleNavBlurOnScroll)
	// initialize state
	handleNavBlurOnScroll()

	const $placeContainer = $(`.place-container[data-id="${placeID}"]`)
	if( !$placeContainer.length ){
		console.error( `Place container not found for ID: ${placeID}` )
		return
	}

	const placeData = {
		name: $placeContainer.attr( 'data-place-name' ) || placeName,
		description: $placeContainer.attr( 'data-place-description' ) || '',
		rating: $placeContainer.attr( 'data-place-rating' ) || '',
		types: $placeContainer.attr( 'data-place-types' ) || '',
		image: $placeContainer.attr( 'data-place-image' ) || '',
		imageLarge: $placeContainer.attr( 'data-place-image-large' ) || '',
		pricingSymbol: $placeContainer.attr( 'data-place-pricing-symbol' ) || '',
		pricingAmount: $placeContainer.attr( 'data-place-pricing-amount' ) || '',
		pricingLevel: $placeContainer.attr( 'data-place-pricing-level' ) || ''
	}

	$('#place-data').attr( 'data-place-id', placeID )

	// show dialog with basic content
	$dialog.find('.title').text( placeData.name )
	$dialog.find('.small-title').text( placeData.name )
	$dialog.find('.info-container .fw-medium.mb-0').text( placeData.description )

	if( placeData.image ){
		$('#header-image-md').css( 'background-image', `url('${placeData.image}')` )
		await generateGradientFromImage( placeData.image )
	} else {
		applyDefaultGradient()
	}

	let $backdrop = $('#dialog-backdrop')
	if( !$backdrop.length ){
		$backdrop = $( '<div>' ).attr( 'id', 'dialog-backdrop' )
		$body.append( $backdrop )
	} else {
		$backdrop.css( 'opacity', '0' )
	}

	($dialog[0] as HTMLDialogElement).show()
	$body.addClass( 'modal-open' )

	requestAnimationFrame( () => {
		$backdrop.css( 'opacity', '1' )
	})

	requestAnimationFrame( () => {
		$dialog.addClass( 'is-visible' )
		$dialog.scrollTop( 0 )
	})

	const theme =  $('#header').hasClass('dark') ? 'dark' : 'light';
	$dialog.removeClass('light dark').addClass(theme);

	$backdrop.on( 'click', () => {
		dismissPlaceModal( $dialog, $backdrop )
	})

	$dialog.on( 'click', ( event:JQuery.ClickEvent ) => {
		if( event.target === $dialog[0] ){
			dismissPlaceModal( $dialog, $backdrop )
		}
	})

	$dialog.on( 'close', () => {
		$('body').removeClass( 'modal-open' )
		$dialog.removeClass( 'is-visible' )
		if( $backdrop.length ){
			$backdrop.css( 'opacity', '0' )
			setTimeout( () => {
				$backdrop.remove()
			}, 300 )
		}

		// cleanup
		const $actionBar = $('#__actionBar')
		const $tintedGradient = $actionBar.find('.gradient.tinted')
		if( $actionBar.length && $tintedGradient.length ){
			$tintedGradient.css('opacity', '0')
			setTimeout(() => {
				$tintedGradient.remove()
			}, 400)
			const $disclaimer = $actionBar.find('small#no-install-disclaimer')
			if( $disclaimer.length ){
				$disclaimer.removeClass('light dark')
			}
		}
		clearGalleryImages()
		$dialog.off('scroll', handleNavBlurOnScroll)
		$dialog.off('touchstart touchmove touchend')
		$dialog.css({
			'transform': '',
			'transition': ''
		})
	})

	// swipe to dismiss functionality
	let touchStartY:number = 0
	let touchStartTime:number = 0
	let isDismissing:boolean = false
	let lastTranslateY:number = 0

	function resetSwipeState() {
		touchStartY = 0
		touchStartTime = 0
		isDismissing = false
		lastTranslateY = 0
		$dialog.css({
			'transform': '',
			'transition': ''
		})
	}

	$dialog.on('touchstart', (e:JQuery.TouchStartEvent) => {
		const scrollTop:number = $dialog.scrollTop()
		if( scrollTop > 0 )
			return
		
		const touch:Touch = e.originalEvent.touches[0]
		touchStartY = touch.clientY
		touchStartTime = Date.now()
		isDismissing = false
		$dialog.css('transition', 'none')
	})

	$dialog.on('touchmove', (e:JQuery.TouchMoveEvent) => {
		const scrollTop:number = $dialog.scrollTop()
		
		if( touchStartY === 0 || scrollTop > 0 )
			return
		
		const touch:Touch = e.originalEvent.touches[0]
		const deltaY:number = touch.clientY - touchStartY
		
		if( deltaY < 0 )
			return
		
		e.preventDefault()
		
		// resistance
		const resistance:number = 0.6
		const translateY:number = deltaY * resistance
		lastTranslateY = translateY
		
		// transform follows finger
		$dialog.css('transform', `translateY(${translateY}px)`)
		
		// fade backdrop based on swipe distance
		const maxSwipeDistance:number = 150
		const fadeAmount:number = Math.min(translateY / maxSwipeDistance, 1)
		if( $backdrop.length ){
			$backdrop.css('opacity', (1 - fadeAmount * 0.5).toString())
		}
	})

	$dialog.on('touchend', (e:JQuery.TouchEndEvent) => {
		if( touchStartY === 0 )
			return
		
		const touch = e.originalEvent.changedTouches[0]
		const deltaY:number = touch.clientY - touchStartY
		const deltaTime:number = Date.now() - touchStartTime
		const velocity:number = deltaY / deltaTime
		const minSwipeDistance:number = 80
		const minVelocity:number = 0.3
		
		const shouldDismiss:boolean = deltaY > minSwipeDistance && velocity > minVelocity
		if( shouldDismiss ){
			$dialog.css({
				'transition': 'transform 0.3s ease-out',
				'transform': 'translateY(100vh)'
			})
			
			if( $backdrop.length )
				$backdrop.css('opacity', '0')
			
			setTimeout(() => {
				dismissPlaceModal( $dialog, $backdrop )
				resetSwipeState()
			}, 300)
		} else {
			$dialog.css({
				'transition': 'transform 0.3s ease-out',
				'transform': 'translateY(0)'
			})
			
			if( $backdrop.length )
				$backdrop.css('opacity', '1')
			
			setTimeout(() => {
				resetSwipeState()
			}, 300)
		}
	})
	
	$dialog.on('scroll', () => {
		if( touchStartY > 0 && $dialog.scrollTop() > 0 ){
			resetSwipeState()
		}
	})

	const placeSheet = $('#placeSheet')

	// rating
	if( placeData.rating ){
		const rating:number = parseFloat( placeData.rating )

		placeSheet.find( '.rating, .rating-container' ).each( function() {
			const $container = $(this)
			const $stars = $container.find( '.stars' )
			const $ratings = $container.find( '.ratings' )

			$stars.empty()

			for( let i = 1; i <= Math.ceil( rating ); i++ ){
				if( i <= Math.floor( rating )) {
					$stars.append( '<i class="bi bi-star-fill"></i>' )
				} else {
					$stars.append( '<i class="bi bi-star-half"></i>' )
				}
			}

			$ratings.text( placeData.rating )
		})
	} else {
		placeSheet.find( '.rating, .rating-container' ).each(function() {
			const $container = $(this)
			$container.find( '.stars' ).empty()
			$container.find( '.ratings' ).text( '' )
		})
	}

	// categories

	const $categoriesContainer = placeSheet.find( '.categories' )
	$categoriesContainer.empty()
	if( placeData.types ){
		const types = placeData.types.split( ',' ).slice( 0, 3 )
		types.forEach( (type:string) => {
			if( type.trim() ){
				$categoriesContainer.append( `<div class="category">${type.trim()}</div>` )
			}
		})
	}

	// pricing
	const $pricingContainer = placeSheet.find( '.pricing-info-container' )
	if( placeData.pricingSymbol || placeData.pricingAmount || placeData.pricingLevel ){
		$pricingContainer.removeClass('d-none')

		const pricingAmount:number = parseFloat( placeData.pricingAmount )
		if( pricingAmount === 0 ){
			$pricingContainer.find('.pricing-symbol').text('')
			$pricingContainer.find('.pricing-amount').text('FREE')
			$pricingContainer.find('.pricing-level').text('')
		} else {
			$pricingContainer.find('.pricing-symbol').text( placeData.pricingSymbol )
			$pricingContainer.find('.pricing-amount').text( placeData.pricingAmount )
			$pricingContainer.find('.pricing-level').text( placeData.pricingLevel )
		}
	} else {
		$pricingContainer.addClass( 'd-none' )
	}

	if( placeData.imageLarge ){
		$('#header-image').css( 'background-image', `url('${placeData.imageLarge}')` )
	}

	await initPlaceSheet( placeDetailsFetcher, onDismiss )
}


export function dismissPlaceModal( $dialog:JQuery<HTMLElement>, $backdrop?:JQuery<HTMLElement> ) {
	$dialog.removeClass( 'is-visible' )
	if( $backdrop )
		$backdrop.css( 'opacity', '0' )

	clearGalleryImages()

	setTimeout( () => {
		const dialogElement = $dialog[0] as HTMLDialogElement
		if( dialogElement.open )
			dialogElement.close()
	}, 300 )
	
	$dialog.removeClass('light dark');

	// notify callback
	if( _onDismiss ){
		_onDismiss()
		_onDismiss = null
	}
}


function clearGalleryImages() {
	const galleryContainer = $('.gallery-grid')
	if( !galleryContainer.length )
		return

	galleryContainer.find( '.photo-container' ).each( (_, container:HTMLElement) => {
		const $container = $(container)
		const $img = $container.find( '.lazy-image' )
		const $placeholder = $container.find( '.placeholder' )

		$img.hide()
		$placeholder.show()

		$container.attr( 'data-loading-state', 'NotLoaded' )

		$container.show()
	})
}
